import * as React from 'react'
import { ActionMenuHandlers } from './Types'
import {
  ActivityActionModalType,
  ActivityActionModalContextValue,
} from 'screens/Activity/components/ActionModal/ActivityActionModalContext'
import { TimelineEvent } from 'screens/Activity/Types'
import { Item } from '@react-stately/collections'
import { ReactComponent as CopyIcon } from 'assets/icons/copy16.svg'
import { ReactComponent as BranchIcon } from 'assets/icons/branch16.svg'
import { ReactComponent as PencilIcon } from 'assets/icons/pencil16.svg'
import { ReactComponent as RestoreIcon } from 'assets/icons/restore16.svg'

export const defaultHandlers: ActionMenuHandlers = {
  [ActivityActionModalType.Branch]: ({ openModal }, event) => {
    openModal(ActivityActionModalType.Branch, event)
  },
  [ActivityActionModalType.Restore]: ({ openModal }, event) => {
    openModal(ActivityActionModalType.Restore, event)
  },
  [ActivityActionModalType.Copy]: ({ openModal }, event) => {
    openModal(ActivityActionModalType.Copy, event)
  },
}

export const createActionHandlers = (
  actionModalContext: ActivityActionModalContextValue,
  event: TimelineEvent,
  handlers: ActionMenuHandlers,
) => {
  return (handlerKey: React.ReactText) => {
    handlers[handlerKey](actionModalContext, event)
  }
}

export const branchAction = (withIcon = false) => (
  <Item key="branch" textValue="Create a linked copy from this point">
    {withIcon && <BranchIcon />}
    Create a linked copy from this point
  </Item>
)

export const copyAction = (withIcon = false) => (
  <Item key="copy" textValue="Make a copy">
    {withIcon && <CopyIcon />}
    Make a copy
  </Item>
)

export const renameAction = (withIcon = false) => (
  <Item key="rename" textValue="Name this event">
    {withIcon && <PencilIcon />}
    Name this event
  </Item>
)

export const restoreAction = (withIcon = false) => (
  <Item key="restore" textValue="Restore from this event">
    {withIcon && <RestoreIcon />}
    Restore from this event
  </Item>
)
